// Native disclosures share dismissal behavior; Flux keeps ownership of its menus.
const selector = 'details[data-shell-disclosure]';
const close = (details, restoreFocus = false) => {
    details.open = false;
    if (restoreFocus) details.querySelector(':scope > summary')?.focus();
};
document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    for (const details of document.querySelectorAll(`${selector}[open]`)) {
        const ownsFocus = details.contains(document.activeElement);
        close(details, ownsFocus);
        if (ownsFocus) event.preventDefault();
    }
});
document.addEventListener('pointerdown', event => {
    for (const details of document.querySelectorAll(`${selector}[open]`)) {
        if (!details.contains(event.target)) close(details);
    }
});
document.addEventListener('toggle', event => {
    if (!(event.target instanceof HTMLDetailsElement) || !event.target.matches(selector) || !event.target.open) return;
    for (const details of document.querySelectorAll(`${selector}[open]`)) {
        if (details !== event.target) close(details);
    }
}, true);
document.addEventListener('livewire:navigating', () => {
    for (const details of document.querySelectorAll(`${selector}[open]`)) close(details);
});
